import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "@mantine/dates/styles.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { MantineProvider } from "@mantine/core";
import { theme } from "./theme";
import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import Dashboard from "./pages/Dashboard";
import Companies from "./pages/Companies";
import AdminUsers from "./pages/AdminUsers";
import Settings from "./pages/Settings";
import { AuthProvider } from "./context/AuthContext";
import NewAdminUser from "./pages/NewAdminUser";
import LoginPage from "./pages/LoginPage";
import PrivateRoutes from "./routes/PrivateRoute";
import PublicRoutes from "./routes/PublicRoute";
import { Notifications } from "@mantine/notifications";
import NewCompany from "./pages/NewCompany";
import CompanyDetail from "./pages/CompanyDetail";
import CompaniesUpdateForm from "./components/Companies/CompaniesUpdateForm"; 
import AdminUsersUpdateFormPage from "./components/AdminUsers/AdminUsersUpdateForm";
import NewPanelUser from "./components/CompanyDetail/NewPanelUser";
import PanelUserUpdateForm from "./components/CompanyDetail/PanelUserUpdateForm"; 
import NewEmployee from "./components/common/NewEmployee";
import EmployeesUpdateForm from "./components/CompanyDetail/EmployeesUpdateForm";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <MantineProvider theme={theme}>
        <Notifications />
        <BrowserRouter>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route path="/" element={<App />}>
                <Route index element={<Navigate to="dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} index />
                <Route path="companies">
                  <Route index element={<Companies />} />
                  <Route path="new" element={<NewCompany />} />
                  <Route path="edit/:id" element={<CompaniesUpdateForm />} />
                  <Route path="detail/:id" element={<CompanyDetail />} />  
                  <Route path="detail/:id/panel-users/new" element={<NewPanelUser />} />
                  <Route path="detail/:id/panel-users/edit/:userId" element={<PanelUserUpdateForm />} />
                  <Route path="detail/:id/employees/new" element={<NewEmployee />} />
                  <Route path="detail/:id/employees/edit/:employeeId" element={<EmployeesUpdateForm />} />
                </Route>
                <Route path="admin-users">
                  <Route index element={<AdminUsers />} />
                  <Route path="new" element={<NewAdminUser />} />
                  <Route path="edit/:id" element={<AdminUsersUpdateFormPage />} /> 
                </Route>
                <Route path="settings" element={<Settings />} />
                <Route path="*" element={<div>404 NOT FOUND</div>} />
              </Route>
            </Route>
            <Route element={<PublicRoutes />}>
              <Route path="/login" element={<LoginPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </MantineProvider>
    </AuthProvider>
  </React.StrictMode>
);
